import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { GenericSimpleButton, GenericModalButton } from 'com-gyf-webcore-userinterfacecomponents';
import ProcessManager from '../../../Common/Managers/ProcessManager';

const BotonCancelar = (props) => {
    let component;
    if (sessionStorage.getItem('PantallaCambios') == "true") {
        component = <GenericModalButton text="Cancelar" buttonClass="btn btn-secondary" dataTarget="#discardChangesModal" />;
    }
    else {
        component =
            <Link onClick={() => props.cleanStorage()} to={ProcessManager.GetNextStep("PermisosMasivos", "ROUTE_TO_PERFYPERM")}>
                <GenericSimpleButton text="Cancelar" buttonClass="btn btn-secondary" />
            </Link>;
    }


    return (
        <div className="dropdown">
            {component}
        </div>
    );
}

export default BotonCancelar